import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

export const Headline = styled.span``;

export const SponsorHeadline = styled.span`
  font-family: ${fontRobotoCondensed};
  font-style: italic;
`;

export const Container = styled.h2``;
